import OBase from './OBase';
import * as Geometry from '../geometry';

// next用のコンポーネント
// エラーが出ないようにダミーのupdateを定義しておく
export default class EParameterConfig extends OBase {
    update(){}
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EParameterConfig.js